import CompanyRoutes from "../../../apiRoutes/CompanyRoutes";
import { GET, POST, POST_JSON } from "../../ConsumeApiController";

export async function getEconomies()
{
    const response = await GET(CompanyRoutes.Cashless.Economies.GetAll);
    return response;
}

export async function create(name,mode,type,technology,description,terms_and_conditions)
{
    const response = await POST_JSON(CompanyRoutes.Cashless.Economies.Create,{
        name,
        mode,
        type,
        technology,
        description,
        terms_and_conditions
    });

    return response;
}

export async function getEconomyByUuid(uuid)
{
    const response = await GET(CompanyRoutes.Cashless.Economies.GetByUUID+uuid);
    return response;
}

